import gql from 'graphql-tag'

export const RefreshTokenPartner = gql`
    mutation($refreshToken: String!) {
        refreshTokenPartner(refreshToken: $refreshToken) {
            access_token
            refresh_token
        }
    }
`
